export const types = {
    SET_GET_PROMO: '[PROMO] SET GET PROMO',
    SET_GET_PROMO_BY_ID: '[PROMO] SET GET PROMO BY ID',
    SET_GET_PROMO_COUNT_USERS: '[PROMO] SET GET PROMO COUNT USERS',
    SET_GET_PROMO_TRANSACTION: '[PROMO] SET GET PROMO TRANSACTION',
    SET_GET_PROMO_BY_PARTNER_ID: '[PROMO] SET GET PROMO BY PARNTER ID'
}